import React from "react";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import Slider from "./../Elements/Slider";
import Specialization from "./../Elements/Specialization";
import About from "./../Elements/About";
import OurValue from "./../Elements/OurValue";
import OurMission from "./../Elements/OurMission";
import ProblemSolution from "./../Elements/ProblemSolution";
import DigitalAdvantage from "./../Elements/DigitalAdvantage";
// import OurServices from './../Elements/OurServices';
import Callus from "./../Elements/Callus";
import OurProject from "./../Elements/OurProject";
// import Blogs from './../Elements/Blogs';
import Testimonials from "./../Elements/Testimonials";

class Home extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Slider />
          <Specialization />
          <About />
          <ProblemSolution />
          <DigitalAdvantage />
          <OurValue />
          <OurProject />
          <OurMission />
          {/* <OurServices /> */}
          {/* <Callus /> */}

          {/* <Blogs /> */}
          <Testimonials />
        </div>
        <Footer />
      </>
    );
  }
}

export default Home;
